import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const routes: Array<RouteRecordRaw> = [
  {
    component: DefaultLayout,
    path: "/default-layout",
    children: [
      {
        path: "/",
        name: "home",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: () => import("../views/HomeView.vue"),
      },
      {
        path: "/contact",
        name: "contact",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: () => import("../views/ContactView.vue"),
      },
      {
        path: "/our-locations",
        name: "our-locations",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: () => import("../views/MapView.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }
    // always scroll to top
    return { top: 0 };
  },
});

router.onError((error, to) => {
  if (
    error.message.includes("Failed to fetch dynamically imported module") ||
    error.message.includes("Loading chunk") ||
    error.message.includes("Importing a module script failed")
  ) {
    window.location.href = to.fullPath;
  }
});

export default router;
